import React from 'react';
import { chapters } from '../data/horizon';
import { scrollTo } from '../utils/scroll';
import { useActiveChapter } from '../hooks/useActiveChapter';
export function DesktopIndex() {
  const active = useActiveChapter();
  return <nav aria-label="Capítulos de la guía" className="sticky top-28" data-id="element-281" data-mp="3cimcqpowvqph">
      <p className="font-cinzel text-sm font-bold text-white mb-5" data-id="element-282" data-mp="37lm8mkbmgy10">Capítulos</p>
      <ol className="space-y-1 border-l border-white/10" data-id="element-283" data-mp="32lhrcs2w3z9q">
        {chapters.map((c, i) => <li key={c.id} data-id="element-284" data-mp="2xmn0r3yol6f2" data-mpi={i}>
            <a href={`#${c.id}`} onClick={e => {
          e.preventDefault();
          scrollTo(c.id);
        }} aria-current={active === c.id ? 'true' : undefined} className={`-ml-px flex items-baseline gap-3 border-l-2 py-1.5 pl-4 text-sm transition-colors duration-200 ${active === c.id ? 'border-[#D4AF37] text-[#D4AF37]' : 'border-transparent text-gray-500 hover:text-gray-200'}`} data-id="element-285" data-mp="2xmdg7vwenrgr">
              <span className="font-cinzel text-xs tabular-nums w-5" data-id="element-286" data-mp="mvdc8rp6kput">{String(i + 1).padStart(2, '0')}</span>
              <span className="whitespace-nowrap" data-id="element-287" data-mp="jisfeuvl096m">{c.short}</span>
            </a>
          </li>)}
      </ol>
    </nav>;
}